export { AuthService, LoginOpt } from './src/auth.service';
export { SocialLoginModule } from './src/sociallogin.module';
export { SocialUser } from './src/entities/user';
export { GoogleLoginProvider } from './src/providers/google-login-provider';
export { FacebookLoginProvider } from './src/providers/facebook-login-provider';
export { LinkedInLoginProvider } from './src/providers/linkedIn-login-provider';
export { AuthServiceConfig } from './src/auth.service';
